import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DialogContent from 'components/DialogContent';
import { EmojiSad } from 'components/icons';
import { onShowFreeTrialModal } from 'redux/modules/mixpanel';
import { modalParamsSelector } from 'redux/modules/modal';
import { Dispatch } from 'redux/types';
import { COUPON_DETAILS, PRO_TRIAL_DETAILS } from './constants';

export interface PromoUnavailableModalContentsProps {
  onHide?: () => void;
}

const PromoUnavailableModalContents: React.FC<PromoUnavailableModalContentsProps> = ({
  onHide,
}) => {
  const { rewardType } = useSelector(modalParamsSelector) || {};

  const dispatch = useDispatch<Dispatch>();

  const { title, description, cta } =
    rewardType === 'proTrial' ? PRO_TRIAL_DETAILS : COUPON_DETAILS;

  useEffect(() => {
    dispatch(onShowFreeTrialModal('PromoUnavailable'));
  }, [dispatch]);

  return (
    <DialogContent
      actions={[
        {
          children: cta,
          key: 'submit',
          onClick: onHide,
          theme: 'submit',
        },
      ]}
      details={description}
      icon={<EmojiSad />}
      title={title}
    />
  );
};

export default PromoUnavailableModalContents;
